<template>
  <div class="appointmentList-view">
    <el-form ref="ruleForm" class="ruleForm" label-width="100px">
      <el-form-item :label="$t('business', 'name')">
        <div class="flex-a-c">
          <el-select v-model="formdata.empId" :filterable="true" :disabled="type == 'edit' ? true : false"
            style="width: 240px;margin-bottom:20px" :placeholder="$t('business', 'selectName')">
            <el-option v-for="(item, index) in memberList" :key="index" :label="item.name" :value="item.empId" />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item :label="$t('business', 'responsibleDepartment')">
        <div class="flex-a-c">
          <el-select v-model="formdata.departmentId" style="width: 240px;" :placeholder="$t('business', 'selectName')">
            <el-option v-for="(item, index) in departmentList" :key="index" :label="item.name"
              :value="item.departmentId" />
          </el-select>
          <div class="flex-a-c ml20" style="color: #8d97ad; font-size: 14px" v-if="departmentList.length == 0">
            {{ $t('business', 'noDepartment') }}
            <el-button class="v-primary ml10" type="primary" @click="toSectorSetupList">{{ $t('business', 'goToSettings') }}</el-button>
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="状态">
        <el-switch
          v-model="formdata.empStatus">
        </el-switch>
      </el-form-item> -->
      <el-form-item :label="$t('business', 'permissions')">
        <el-tree :data="treeData" ref="tree" :props="defaultProps" show-checkbox accordion @check="currentChange"
          node-key="id"></el-tree>
      </el-form-item>
      <el-form-item>
        <p class="ml10" v-if="formdata.routers.length === 0">{{ $t('business', 'noPermissionsSelected') }}</p>
        <p class="ml10" v-else>{{ $t('business', 'permissionsSelected') }}: {{ formdata.routers.length }}</p>
        <el-button class="v-primary ml10" type="primary" @click="saveManager">{{ $t('business', 'save') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import {
  queryPageEmployee,
  queryPageDepartment,
  addManager,
  queryEmployee,
  updateManager
} from "@/api/companyManage.js";
import userRoot from '@/utils/root'
import { processI18nPermissions } from '@/utils/root';
import i18nMixin from '@/mixins/i18nMixin'

export default {
  name: "appointmentList",
  mixins: [i18nMixin],
  data() {
    return {
      memberList: [],
      departmentList: [],
      treeData: [],
      defaultProps: {
        children: 'subs',
        label: 'title'
      },
      formdata: {
        empId: '',
        departmentId: '',
        empStatus: false,
        routers: userRoot.defaultRouters,
        userType: 1  //用户类型 0 默认员工 1管理员 2 boss
      },
      type: 'add'
    };
  },
  watch: {
    // 监听语言变化，强制更新组件
    currentLanguage() {
      this.$forceUpdate();
      // 重新处理权限数据以更新语言
      this.treeData = processI18nPermissions(userRoot.userRoot, this.currentLanguage);
    }
  },
  mounted() {
    this.getPageEmployee()
    this.getPageDepartment()
    
    // 使用processI18nPermissions处理多语言权限数据
    this.treeData = processI18nPermissions(userRoot.userRoot, this.currentLanguage);
    
    if (this.$route.query.id) {
      this.type = 'edit'
      this.queryEmployee()
    }
    this.$refs.tree.setCheckedKeys(this.formdata.routers)
  },
  methods: {
    ...mapMutations(['setRouterArr']),
    //获取企业成员
    getPageEmployee() {
      let data = {
        pageSize: 999,
      };
      queryPageEmployee(data)
        .then((res) => {
          this.memberList = res.data.pageInfo.list || [];
        })
        .catch((err) => {
          this.departmentList = [];
          console.log(err);
        });
    },
    //请求部门信息
    getPageDepartment() {
      let data = {
        pageSize: 999,
      };
      queryPageDepartment(data)
        .then((res) => {
          this.departmentList = res.data.pageInfo.list || [];
        })
        .catch((err) => {
          this.departmentList = [];
          console.log(err);
        });
    },
    //保存管理员
    async saveManager() {
      if (!this.formdata.empId) {
        this.$message.error(this.$t('business', 'pleaseSelectAdministrator'))
        return
      }
      let result = ''
      if (this.type == 'add') {
        result = await addManager(this.formdata)
      } else {
        result = await updateManager(this.formdata)
      }
      if (result && result.code == 200) {
        this.$message.success(this.type == 'add' ? this.$t('common', 'saveSuccess') : this.$t('common', 'modifySuccess'))
        this.$router.go(-1)
      } else {
        this.$message.error(result && result.message ? result.message : this.$t('business', 'operationFailed'))
      }
    },
    //查询管理员详情
    queryEmployee() {
      let data = {
        empId: this.$route.query.id
      }
      queryEmployee(data)
        .then(res => {
          this.formdata.empId = res.data.empId
          this.formdata.departmentId = res.data.departmentId
          this.formdata.empStatus = res.data.empStatus
          if (res.data.routers && res.data.routers !== 'null') {
            this.formdata.routers = JSON.parse(res.data.routers)
          } else {
            this.formdata.routers = userRoot.defaultRouters
          }
          
          // 重新处理权限数据以确保语言正确
          this.treeData = processI18nPermissions(userRoot.userRoot, this.currentLanguage);
          this.formdata.routers = this.filtration(this.treeData)
          this.formdata.userType = res.data.userType
          this.$refs.tree.setCheckedKeys(this.formdata.routers)
        })
    },
    currentChange(a, b) {
      this.formdata.routers = b.checkedKeys.concat(...b.halfCheckedKeys)
    },
    filtration(treeData) {
      for (let index = 0; index < treeData.length; index++) {
        let data = treeData[index]
        if (data.subs) {
          let index = this.formdata.routers.findIndex(item => item == data.id)
          if (index !== -1) {
            this.formdata.routers.splice(index, 1)
          }
          this.filtration(data.subs)
        }
      }
      return this.formdata.routers
    },
    toSectorSetupList() {
      this.$router.push('/sectorSetup')
    }
  },
  beforeDestroy() {
    if (this.$refs.tree) {
      this.$refs.tree = null;
    }
    if (this.$refs.ruleForm) {
      this.$refs.ruleForm = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}

.member-box {
  padding: 5px 10px;
  background: #51CDCB;
  display: flex;
  justify-content: center;
  align-items: center;
  font: 14px;
  color: #ffffff;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 3px;
}

.more-box {
  padding: 5px 10px;
  background: #FD634E;
  display: flex;
  justify-content: center;
  align-items: center;
  font: 14px;
  color: #ffffff;
  border-radius: 3px;
}

.member-scroll {
  max-height: 300px;
  overflow-y: auto;
}
</style>